import AdminLayout from "../components/AdminLayout";
import TableCollection from "../components/TableCollection";

const AdminCollection = () => {
  return (
    <AdminLayout title="Collections" stats="default">
      <TableCollection />
    </AdminLayout>
  );
};

export default AdminCollection;
